import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]


const __default__ = {};

interface IProps {
  fill_top?: string;
  fill_bottom?: string;
  width?: number;
  height?: number;
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IconCornerNew',
  props: {
    fill_top: { default: "#2FB925" },
    fill_bottom: { default: "#FFE400" },
    width: { default: 16 },
    height: { default: 16 }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.width,
    height: _ctx.height,
    viewBox: `0 0 ${_ctx.width} ${_ctx.height}`,
    fill: "none"
  }, [
    _createElementVNode("path", {
      d: "M9.74345 9.27441C8.47976 11.1819 6.23298 12.3029 3.95126 12.2119C3.63892 12.2115 3.00548 12.2122 2.69283 12.2119L0.666992 13.9993H9.74345L12.667 9.27441H9.74345Z",
      fill: _ctx.fill_top
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M4.23031 11.2749C5.88703 11.2792 7.49953 10.5282 8.56656 9.27492H5.99969V4.18617L9.88406 2.36273L5.06219 0.0996094V9.5643L3.53125 11.2749H4.23031Z",
      fill: _ctx.fill_bottom
    }, null, 8, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})